/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiRoamingWhatsnewurlGet$Params {

/**
 * Localization
 */
  lang?: string;

/**
 * Application type. 1 - Web, 2 - Mobile
 */
  appType?: number;

/**
 * Platform
 */
  mobilePlatform?: string;

/**
 * Version
 */
  version?: string;
}

export function apiRoamingWhatsnewurlGet(http: HttpClient, rootUrl: string, params?: ApiRoamingWhatsnewurlGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiRoamingWhatsnewurlGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('appType', params.appType, {});
    rb.query('mobilePlatform', params.mobilePlatform, {});
    rb.query('version', params.version, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiRoamingWhatsnewurlGet.PATH = '/api/Roaming/whatsnewurl';
